var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(_vm.currentUser?.id && this.$router.currentRoute.name != 'LoginView')?_c('sidebar-component',{staticClass:"hidden-sm-and-down"}):_vm._e(),_c('div',{staticClass:"w-100",class:{ 'content-wrap': _vm.currentUser?.id && this.$router.currentRoute.name != 'LoginView' }},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }